import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel as relText } from '../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';
import { getSeriesRankList } from '../../../../services/api';
import { classnames } from '../../../../utils/classnames';

class SeriesRank extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { seriesRankList, infoTitle, infoUrl } = this.props.content;

        return (
            <div className={styles.series_rank}>
                <div className={`${styles.series_rank_title} clearfix`}>
                    <i className={classnames(styles.block, 'block')} />
                    <span className={styles.link_title}>{infoTitle}</span>
                    {infoUrl ? (
                        <a className={styles.more} href={infoUrl} target="_blank" rel={relText}>
                            更多&gt;
                        </a>
                    ) : null}
                </div>
                <div className={styles.arl_md_rank}>
                    <ul>
                        {seriesRankList.length > 0 &&
                            seriesRankList.slice(0, 3).map((item, index) => (
                                <li className={styles.nt} key={index}>
                                    <span className={styles.n}>{index + 1}</span>
                                    <a
                                        className={styles.img}
                                        target="_blank"
                                        rel={relText}
                                        title={item.standardName}
                                        href={`https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`}>
                                        <img width="120" height="80" src={item.logo} alt={item.standardName} />
                                    </a>
                                    <a
                                        className={styles.name}
                                        target="_blank"
                                        rel={relText}
                                        title={item.standardName}
                                        href={`https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`}>
                                        {item.standardName}
                                    </a>
                                    <a
                                        target="_blank"
                                        rel={relText}
                                        title={item.standardName}
                                        href={`https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`}>
                                        <span className={styles.price}>{item.guidePrice}</span>
                                    </a>
                                </li>
                            ))}
                        {seriesRankList.length > 0 &&
                            seriesRankList.slice(3, seriesRankList.length).map((item, index) => (
                                <li key={index}>
                                    <span className={styles.n}>{index + 4}</span>
                                    <a
                                        className={styles.name}
                                        target="_blank"
                                        rel={relText}
                                        title={item.standardName}
                                        href={`https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`}>
                                        {item.standardName}
                                    </a>
                                    <a
                                        target="_blank"
                                        rel={relText}
                                        title={item.standardName}
                                        href={`https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`}>
                                        <span className={styles.price}>{item.guidePrice}</span>
                                    </a>
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(SeriesRank);
